import service from "./service";

const login = async (payload) => {
  return service.post("/admin/login", payload).then((response) => {
    return response;
  });
};

const verifyToken = async () => {
  return service.get("/admin/verify-token").then((response) => {
    return response;
  });
};

const logout = async () => {
  return service.get("/admin/logout").then((response) => {
    return response;
  });
};

const adminProfile = async () => {
  return service.get("/admin/profile").then((response) => {
    return response;
  });
};

const dashboard = async () => {
  return service.get("/admin/dashboard").then((response) => {
    return response;
  });
};
const adminNotification = async (page, limit) => {
  return service
    .get(`/admin/notifications?&page=${page}&limit=${limit}`)
    .then((response) => {
      return response;
    });
};

export default {
  login,
  verifyToken,
  logout,
  adminProfile,
  dashboard,
  adminNotification,
};
